import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import myStore from "state/store";
import { AppRouter } from "app/AppRouter";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "components/ErrorBoundary";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container #root not found in index.html");
}

createRoot(container).render(
  <React.StrictMode>
    <ErrorBoundary label="The app">
      <Provider store={myStore}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
